/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Spacex_Detail_OpenInputs */

const en_campaigns_mag7_spacex_detail_open = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Mag7X Strategy on Glider.`)
};

const de_campaigns_mag7_spacex_detail_open = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen Sie die Mag7X-Strategie auf Glider.`)
};

const pt_br2_campaigns_mag7_spacex_detail_open = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra a Estratégia Mag7X na Glider.`)
};

const tr_campaigns_mag7_spacex_detail_open = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider’da Mag7X Stratejisini açın.`)
};

const zh_cn2_campaigns_mag7_spacex_detail_open = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Glider 上打开 Mag7X 策略。`)
};

const zh_hk2_campaigns_mag7_spacex_detail_open = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 Glider 開啟 Mag7X 策略。`)
};

const ko_kr2_campaigns_mag7_spacex_detail_open = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider에서 Mag7X 전략을 여세요.`)
};

const ru_ru2_campaigns_mag7_spacex_detail_open = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте стратегию Mag7X на Glider.`)
};

const es_419_campaigns_mag7_spacex_detail_open = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre la estrategia Mag7X en Glider.`)
};

/**
* | output |
* | --- |
* | "Open the Mag7X Strategy on Glider." |
*
* @param {Campaigns_Mag7_Spacex_Detail_OpenInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_detail_open = /** @type {((inputs?: Campaigns_Mag7_Spacex_Detail_OpenInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Detail_OpenInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_detail_open(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_detail_open(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_detail_open(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_detail_open(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_detail_open(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_detail_open(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_detail_open(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_detail_open(inputs)
	return es_419_campaigns_mag7_spacex_detail_open(inputs)
});